module.exports = __webpack_public_path__ + "static/media/3rd.d63da911.jpg";